import { PropsWithChildren, JSX, useRef } from 'react';
import classNames from 'classnames';
import { useMobileView } from '@betgames/bg-tools';
import { useRestoreScrollPosition, CONTAINER_WIDTH } from '@bg-shared';
import classes from './ModalContent.module.scss';

interface IProps {
    className?: string;
    dataQa?: string;
}

export const ModalContent = (props: PropsWithChildren<IProps>): JSX.Element => {
    const ref = useRef<HTMLDivElement>();
    const isMobileView = useMobileView(CONTAINER_WIDTH);

    useRestoreScrollPosition({ ref, useIframeIntegrationVersion: isMobileView });

    return (
        <div
            data-qa={props.dataQa}
            className={classNames(classes.container, props.className)}
            ref={ref}
        >
            {props.children}
        </div>
    );
};
